import api from '@/api/';
import tips from '@/components/tips/main';
import qs from "qs"
import instantiationPromise from "@/library/promiseTool";
let authorizeUnion = {
  doAuth () {
    let redirectOauthUrl = window.location.protocol + `//h5.mgzf.com${window.location.pathname}${window.location.search}`;  // 转换过后的redirectUrl
    // 获取对应环境appId, 并去授权页面
    api.authorize.loadAppIdConfig()
      .then(({data}) => {
        if (data.code == 10000) {
          location.href =`https://open.95516.com/s/open/html/oauth.html?appId=${data.content}&redirectUri=${window.encodeURIComponent(redirectOauthUrl)}&responseType=code&scope=upapi_mobile&state=${window.encodeURIComponent(window.location.origin)}&timestamp=${new Date().getTime()}`;
        }
      }).catch(err => {
      tips('获取appid失败!')
    })
  },
  doCode () {
    let tempQuery = qs.parse(window.location.href.split('?')[1]);
    let code = tempQuery.code.replace(/ /g, '+');
    delete tempQuery.code;
    let querystring = qs.stringify(tempQuery);
    if (querystring) {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}?` + querystring);
    } else {
      window.history.replaceState({}, "", `${location.origin}${location.pathname}`);
    }
    let {resolve:_resolveTemp ,reject:_rejectTemp, promise:promiseTemp} = instantiationPromise ();
    api.authorize.unionPayAuthorize({
      code
    })
      .then(({data: {code, content, message}}) => {
        if (code == 10000) {
          let auth = {
            userId: content.renterId,
            mobile: content.mobile,
            token: content.token
          }
          _resolveTemp(auth)
        } else {
          _rejectTemp(message)
          tips(message)
        }
      })
      .catch(err => {
        _rejectTemp('授权失败!')
        tips('授权失败')
      })
    return promiseTemp
  }
}

export default authorizeUnion


// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeUnion.js